import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';

const Categories = () => {
  const navigate = useNavigate();
  const [selectedCategory, setSelectedCategory] = useState(null);

  const categories = [
    {
      id: 'fashion',
      name: 'Mode & Accessoires',
      icon: '👗',
      image: 'https://images.unsplash.com/photo-1441986300917-64674bd600d8?w=200&h=200&fit=crop',
      platforms: ['Shein', 'Amazon', 'AliExpress', 'Zalando']
    },
    {
      id: 'electronics',
      name: 'Électronique',
      icon: '📱',
      image: 'https://images.unsplash.com/photo-1498049794561-7780e7231661?w=200&h=200&fit=crop',
      platforms: ['Amazon', 'Alibaba', 'AliExpress', 'eBay']
    },
    {
      id: 'home',
      name: 'Maison & Jardin',
      icon: '🏠',
      image: 'https://images.unsplash.com/photo-1586023492125-27b2c045efd7?w=200&h=200&fit=crop',
      platforms: ['Alibaba', 'Amazon', 'AliExpress', 'IKEA']
    },
    {
      id: 'beauty',
      name: 'Beauté',
      icon: '💄',
      image: 'https://images.unsplash.com/photo-1522338247332-321f44d1be92?w=200&h=200&fit=crop',
      platforms: ['Shein', 'Amazon', 'AliExpress', 'Sephora']
    },
    {
      id: 'shoes',
      name: 'Chaussures',
      icon: '👟',
      image: 'https://images.unsplash.com/photo-1542291026-7eec264c27ff?w=200&h=200&fit=crop',
      platforms: ['Shein', 'Amazon', 'AliExpress', 'Nike']
    },
    {
      id: 'sports',
      name: 'Sports & Loisirs',
      icon: '🎮',
      image: 'https://images.unsplash.com/photo-1571019613454-1cb2f99b2d8b?w=200&h=200&fit=crop',
      platforms: ['Amazon', 'Alibaba', 'AliExpress', 'Decathlon']
    },
    {
      id: 'jewelry',
      name: 'Bijoux & Montres',
      icon: '💍',
      image: 'https://images.unsplash.com/photo-1515562141207-7a88fb7ce338?w=200&h=200&fit=crop',
      platforms: ['Shein', 'Amazon', 'AliExpress', 'Pandora']
    },
    {
      id: 'toys',
      name: 'Enfants & Jouets',
      icon: '🧸',
      image: 'https://images.unsplash.com/photo-1555252333-9f8e92e65df9?w=200&h=200&fit=crop',
      platforms: ['Amazon', 'Alibaba', 'AliExpress', 'Lego']
    }
  ];

  const platformUrls = {
    'Shein': 'https://www.shein.com',
    'Amazon': 'https://www.amazon.com',
    'Alibaba': 'https://www.alibaba.com',
    'AliExpress': 'https://www.aliexpress.com',
    'Zalando': 'https://www.zalando.com',
    'eBay': 'https://www.ebay.com',
    'IKEA': 'https://www.ikea.com',
    'Sephora': 'https://www.sephora.com',
    'Nike': 'https://www.nike.com',
    'Decathlon': 'https://www.decathlon.com',
    'Pandora': 'https://www.pandora.net',
    'Lego': 'https://www.lego.com'
  };

  const handleCategoryClick = (category) => {
    setSelectedCategory(category);
  };

  const handlePlatformClick = (platform) => {
    const url = platformUrls[platform];
    if (url) {
      window.open(url, '_blank', 'noopener,noreferrer');
    }
  };

  const handleCreateOrder = (platform) => {
    navigate('/order', { state: { platform } });
  };

  return (
    <div>
      <Navbar />

      <div className="container">
        <div style={{ maxWidth: '1400px', margin: '40px auto', padding: '20px' }}>
          <h1 style={{ marginBottom: '10px', color: '#FF0000', fontSize: '32px', fontWeight: '700', textAlign: 'center' }}>
            🛍️ Toutes les Catégories
          </h1>
          <p style={{ marginBottom: '40px', color: '#666', textAlign: 'center', fontSize: '18px' }}>
            Explorez nos catégories et découvrez les meilleures plateformes e-commerce pour vos achats
          </p>

          {!selectedCategory ? (
            <div className="categories-grid" style={{ marginBottom: '40px' }}>
              {categories.map((category) => (
                <div
                  key={category.id}
                  className="category-item"
                  onClick={() => handleCategoryClick(category)}
                  style={{
                    cursor: 'pointer',
                    transition: 'all 0.3s ease'
                  }}
                >
                  <div className="category-icon">
                    <img
                      src={category.image}
                      alt={category.name}
                      onError={(e) => {
                        e.target.style.display = 'none';
                        e.target.parentElement.innerHTML = `<span style="font-size: 48px;">${category.icon}</span>`;
                      }}
                    />
                  </div>
                  <div className="category-name">{category.name}</div>
                </div>
              ))}
            </div>
          ) : (
            <div>
              <div style={{ marginBottom: '30px', display: 'flex', alignItems: 'center', gap: '20px' }}>
                <button
                  onClick={() => setSelectedCategory(null)}
                  className="btn btn-secondary"
                  style={{ padding: '10px 20px' }}
                >
                  ← Retour aux catégories
                </button>
                <h2 style={{ margin: 0, color: '#333', fontSize: '28px' }}>
                  {selectedCategory.icon} {selectedCategory.name}
                </h2>
              </div>

              <div style={{ marginBottom: '30px', padding: '20px', backgroundColor: '#f8f9fa', borderRadius: '8px' }}>
                <p style={{ margin: 0, color: '#666', lineHeight: '1.8' }}>
                  Choisissez une plateforme e-commerce pour {selectedCategory.name.toLowerCase()}. Vous pouvez soit ouvrir la plateforme directement, soit créer une commande sur Maxfly.
                </p>
              </div>

              <div style={{
                display: 'grid',
                gridTemplateColumns: 'repeat(auto-fill, minmax(280px, 1fr))',
                gap: '20px',
                marginBottom: '40px'
              }}>
                {selectedCategory.platforms.map((platform) => (
                  <div
                    key={platform}
                    className="card"
                    style={{
                      padding: '25px',
                      textAlign: 'center',
                      transition: 'all 0.3s ease',
                      cursor: 'pointer'
                    }}
                    onMouseEnter={(e) => {
                      e.currentTarget.style.transform = 'translateY(-5px)';
                      e.currentTarget.style.boxShadow = '0 8px 20px rgba(0, 0, 0, 0.15)';
                    }}
                    onMouseLeave={(e) => {
                      e.currentTarget.style.transform = 'translateY(0)';
                      e.currentTarget.style.boxShadow = '0 2px 8px rgba(0, 0, 0, 0.08)';
                    }}
                  >
                    <div style={{ fontSize: '48px', marginBottom: '15px' }}>
                      {platform === 'Shein' && '🛍️'}
                      {platform === 'Amazon' && '📦'}
                      {platform === 'Alibaba' && '🏭'}
                      {platform === 'AliExpress' && '🌐'}
                      {platform === 'Zalando' && '👔'}
                      {platform === 'eBay' && '🏪'}
                      {platform === 'IKEA' && '🪑'}
                      {platform === 'Sephora' && '💋'}
                      {platform === 'Nike' && '✓'}
                      {platform === 'Decathlon' && '🏃'}
                      {platform === 'Pandora' && '💎'}
                      {platform === 'Lego' && '🧱'}
                    </div>
                    <h3 style={{ marginBottom: '20px', color: '#333', fontSize: '22px', fontWeight: '600' }}>
                      {platform}
                    </h3>
                    <div style={{ display: 'flex', flexDirection: 'column', gap: '10px' }}>
                      <button
                        onClick={() => handlePlatformClick(platform)}
                        className="btn btn-primary"
                        style={{ width: '100%' }}
                      >
                        🌐 Ouvrir {platform}
                      </button>
                      <button
                        onClick={() => handleCreateOrder(platform)}
                        className="btn btn-secondary"
                        style={{ width: '100%' }}
                      >
                        📦 Commander via Maxfly
                      </button>
                    </div>
                  </div>
                ))}
              </div>

              <div className="card" style={{ padding: '20px', backgroundColor: '#f0f9ff', border: '1px solid #bae6fd' }}>
                <h3 style={{ marginBottom: '15px', color: '#0369a1', fontSize: '20px' }}>
                  💡 Comment ça marche ?
                </h3>
                <div style={{ display: 'grid', gap: '15px', color: '#0369a1' }}>
                  <div style={{ display: 'flex', gap: '15px', alignItems: 'flex-start' }}>
                    <div style={{ fontSize: '24px' }}>1️⃣</div>
                    <div>
                      <strong>Ouvrir la plateforme</strong> : Cliquez sur "Ouvrir {selectedCategory.platforms[0]}" pour accéder directement au site et parcourir les produits.
                    </div>
                  </div>
                  <div style={{ display: 'flex', gap: '15px', alignItems: 'flex-start' }}>
                    <div style={{ fontSize: '24px' }}>2️⃣</div>
                    <div>
                      <strong>Commander via Maxfly</strong> : Cliquez sur "Commander via Maxfly" pour créer une commande. Vous pourrez ensuite coller le lien du produit et nous nous occupons du reste !
                    </div>
                  </div>
                  <div style={{ display: 'flex', gap: '15px', alignItems: 'flex-start' }}>
                    <div style={{ fontSize: '24px' }}>3️⃣</div>
                    <div>
                      <strong>Livraison en RDC</strong> : Nous gérons l'achat, l'expédition et la livraison jusqu'à votre porte en RDC.
                    </div>
                  </div>
                </div>
              </div>
            </div>
          )}
        </div>
      </div>

      <Footer />
    </div>
  );
};

export default Categories;





